export const dealLostReasons = [
    "Pricing / Valuation Gap",
    "Outbid / Sold to Another Party",
    "Site / Property Issue",
    "Seller Not Motivated / Not Ready",
    "Seller / Tenant Timing",
    "Seller Unresponsive",
    "Market / Location Issue",
    "Zoning / Entitlement Issues",
];
